// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import EducationContainer from 'modules/onBoarding/components/Education'

const Education = (): ReactElement => {
  return (
    <DocumentTitle title={`Step 3 - Education | ATD`}>
      <EducationContainer />
    </DocumentTitle>
  )
}

export default Education
